import client from "./client";

/**
 * Public platform counters for landing page.
 */
export async function getPublicPlatformStats() {
  const res = await client.get("/api/v1/public/stats");
  return res.data;
}
